import { Spin } from 'antd';
import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Form, OriSelect, RadioGroup, RadioItem } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { getTagsInSalesChannel } from 'src/request/customer';
import { i18nGet } from 'src/tools/tools';
import CustomerTable from '../CustomerTable';
import css from './css.module.less';

const Item = Form.Item;
export enum ECondition {
  Everyone = 'Everyone',
  Registered = 'Registered',
  Specific = 'Specific',
}

const CustomerEligibleCondition = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { uuid }: any = useParams();
  const [loaded, setLoaded] = React.useState(false);
  const {
    radioName,
    tagsName,
    customerName,
    form,
    disableEdit,
    disabledEveryoneDependency,
  } = props;
  const [tags, setTags] = React.useState([]);
  React.useEffect(() => {
    getTagsInSalesChannel(uuid).then((tags: any) => {
      setTags(tags);
      setLoaded(true);
    });
  }, []);

  //   const _base = 'customerCondition';
  //   const _type = [_base, 'conditionType'];
  //   const _customer = [_base, 'customers'];
  //   const _tags = [_base, 'customerTags'];
  return (
    <Spin spinning={!loaded}>
      <Item
        shouldUpdate={(c, p) => {
          const cV = get(c, disabledEveryoneDependency);
          const pV = get(p, disabledEveryoneDependency);
          return cV !== pV;
        }}>
        {({ getFieldValue }) => {
          const isEnabled = disabledEveryoneDependency
            ? getFieldValue(disabledEveryoneDependency)
            : false;

          return (
            <Item
              name={radioName}
              rules={[
                {
                  required: true,
                  message: getI18n('general.pleaseselectavalue'),
                },
              ]}>
              <RadioGroup className={css.radioGroup} disabled={disableEdit}>
                <RadioItem
                  className={css.radio}
                  value={ECondition.Everyone}
                  disabled={isEnabled}>
                  {getI18n(
                    'salesChannelDirectDiscount.eligibalCondition.everyone',
                  )}
                </RadioItem>
                <RadioItem className={css.radio} value={ECondition.Registered}>
                  {getI18n(
                    'salesChannelDirectDiscount.eligibalCondition.registeredcustomers',
                  )}
                </RadioItem>
                <RadioItem
                  value={ECondition.Specific}
                  className={css.radioLast}>
                  {getI18n(
                    'salesChannelDirectDiscount.eligibalCondition.customertagandspecificcustomers',
                  )}
                </RadioItem>
              </RadioGroup>
            </Item>
          );
        }}
      </Item>

      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, radioName);
          const cV = get(c, radioName);
          return pV !== cV;
        }}>
        {({ getFieldValue }) => {
          const isDisplay = getFieldValue(radioName) === ECondition.Specific;
          if (isDisplay) {
            return (
              <div className={css.customerSelectionContainer}>
                <Item
                  shouldUpdate={(p, c) => {
                    const pV = get(p, tagsName);
                    const cV = get(c, tagsName);
                    const pC = get(p, customerName);
                    const cC = get(c, customerName);
                    return pV !== cV || pC !== cC;
                  }}>
                  {({ getFieldValue }) => {
                    const customers = getFieldValue(customerName) || [];
                    //const _tags = getFieldValue(tagsName) || [];
                    if (
                      form.isFieldTouched(tagsName) ||
                      form.isFieldTouched(customerName)
                    )
                      setTimeout(() => {
                        form.validateFields([tagsName]);
                      });
                    return (
                      <Item
                        name={tagsName}
                        rules={[
                          {
                            validator: async (x, value) => {
                              if (
                                customers.length === 0 &&
                                (value || []).length === 0
                              ) {
                                return Promise.reject(
                                  new Error(
                                    getI18n(
                                      'salesChannelDirectDiscount.eligibalCondition.customerTip',
                                    ),
                                  ),
                                );
                              }
                            },
                          },
                        ]}>
                        {/* <OriSelect
                          size='large'
                          mode='multiple'
                          showSearch
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }>
                          {(tags || []).map((i) => {
                            const { uuid, name } = i;
                            return (
                              <OriSelect.Option value={uuid} key={uuid}>
                                {name}
                              </OriSelect.Option>
                            );
                          })}
                        </OriSelect> */}
                        <_Tags tags={tags} disabled={disableEdit} />
                      </Item>
                    );
                  }}
                </Item>
                <div className={css.tableContainer}>
                  <div className={css.tableTitle}>
                    {getI18n(
                      'salesChannelDirectDiscount.eligibalCondition.specificcustomers',
                    )}
                  </div>
                  <Item name={customerName}>
                    <CustomerTable
                      tableId={'SalesChannelCustomerEligibleTable'}
                      disableEdit={disableEdit}
                    />
                  </Item>
                </div>
              </div>
            );
          }
          return null;
        }}
      </Item>
    </Spin>
  );
};
export default CustomerEligibleCondition;
const _Tags = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { value, onChange, id, tags, disabled } = props;
  const _value = React.useMemo(() => {
    return (value || []).map((i) => {
      return (i || {}).uuid;
    });
  }, [value]);
  const [data, setData] = React.useState(_value);
  React.useEffect(() => {
    if (_value !== data) {
      setData(_value);
    }
  }, [_value]);
  const handleOnChange = (e) => {
    const re = e.map((i) => ({ uuid: i }));
    onChange(re);
  };
  return (
    <OriSelect
      id={id}
      size='large'
      mode='multiple'
      value={data}
      onChange={(e) => {
        setData(e);
        handleOnChange(e);
      }}
      disabled={disabled}
      placeholder={getI18n('general.advancedFilters.customerTag.placeholder')}
      showSearch
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }>
      {(tags || []).map((i) => {
        const { uuid, name } = i;
        return (
          <OriSelect.Option value={uuid} key={uuid}>
            {name}
          </OriSelect.Option>
        );
      })}
    </OriSelect>
  );
};
